import styled from 'styled-components'

import GoBackIcon from '../../../images/icon_chevron_left_white.svg'
import TimesWhiteIcon from '../../../images/icon_times_white.svg'

import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledImgButton = styled.img`
  width: 18px;
  cursor: pointer;
`

export const StyledGameContainer = styled.div`
  color: ${themeStyles.colors.white.main};
  background-color: ${themeStyles.colors.black.main};
  background-size: cover;
  background-position: 50%;
  overflow: hidden;
  position: relative;
`

export const StyledCol = styled.div`
  height: auto;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  display: flex;
`

export const StyledGameWrapper = styled.div`
  height: auto;
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
`

export const StyledIframeWrapper = styled.div`
  background-color: transparent;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: end;
`

export const StyledIframeCashbackWrapper = styled.div`
  display: flex;
  align-items: start;
`

export const StyledTime = styled.div`
  position: relative;
  display: none;

  ${themeMedia.desktop`
    display: block;
  `};
`

export const StyledGameActions = styled.div`
  position: absolute;
  top: 16px;
  right: 30px;
  display: none;

  ${themeMedia.desktop`
    display: flex;
  `};

  flex-direction: column;
  align-items: center;
  gap: 0.4em;
`

export const StyledBtn = styled.button`
  display: block;
  border-radius: 4px;
  background-color: ${themeStyles.colors.black.main};

  svg {
    path {
      fill: ${themeStyles.colors.white.main};
    }
  }
`

export const HEADER_HEIGHT = 50
export const StyledMobileMenu = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: ${HEADER_HEIGHT}px;
  background-color: ${themeStyles.colors.black.main};
  color: ${themeStyles.colors.white.main};
  padding: 0 0.5rem;
  position: sticky;
  top: 0;
  z-index: 495;
`

export const StyledMobileHeaderButton = styled.button`
  background-color: transparent;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 9999;
  width: 15px;
  height: 15px;

  &.close {
    background-image: url(${TimesWhiteIcon});
  }

  &.goBack {
    background-image: url(${GoBackIcon});
  }
`

export const GameWithRGContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const ResponsibleGamingWrapper = styled.div`
  padding: 1rem;
  ${themeMedia.tablet`
    padding: 1rem 0 2rem 0;
  `}
`
